import { render, staticRenderFns } from "./RrcvD_Items.vue?vue&type=template&id=1d0d9eb8"
import script from "./RrcvD_Items.vue?vue&type=script&lang=js"
export * from "./RrcvD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports